import type { UrlState } from '../types';

/** Embedded in panel — do not mutate the host page query string. */
export function readUrlState(): UrlState {
  return {
    q: '',
    sel: '',
    depth: null,
    compact: false,
    dark: false,
    tab: 'tree',
    clusterBy: 'default'
  };
}

export function writeUrlState(_state?: Partial<UrlState>): void {
  // no-op: avoids overwriting Keyword Research route params
}

export async function copyShareUrl(): Promise<string> {
  const url = window.location.href;
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(url);
  }
  return url;
}
